<template>
	<v-container
		class="bkgLogin pa-0"
		fill-height
		fluid
	>
		<v-row class="fill-height bkgOverlay">
			<v-col
				cols="12"
				class="d-flex justify-center align-center"
			>
				<p class="mb-0 text-center">
					<v-img
						class="mx-auto"
						@click="$router.push(`/`)"
						contain
						width="140px"
						height="auto"
						src="../assets/logo-branco.png"
						style="cursor: pointer"
					/>
				</p>
			</v-col>
			<v-col
				cols="12"
				md="8"
				offset-md="2"
			>
				<v-stepper v-model="e1">
					<v-stepper-header>
						<v-stepper-step
							color="#F15A24"
							:complete="e1 > 1"
							step="1"
						>
							Vamos começar
						</v-stepper-step>
						<v-stepper-step
							color="#F15A24"
							:complete="e1 > 2"
							step="2"
							v-if="!planoGratuito"
						>
							Endereço
						</v-stepper-step>
						<v-stepper-step
							color="#F15A24"
							:complete="e1 > 3"
							step="3"
							v-if="!planoGratuito && !cadastroSemPagamento"
						>
							Plano
						</v-stepper-step>
						<v-stepper-step
							color="#F15A24"
							step="4"
						>
							Cadastro finalizado!
						</v-stepper-step>
					</v-stepper-header>
					<v-stepper-items>
						<v-stepper-content step="1">
							<v-card
								elevation="0"
								color="#f2f2f2"
							>
								<v-card-title> Dados pessoais </v-card-title>
								<v-card-text>
									<v-text-field
										filled
										label="Nome"
										hide-details
										prepend-inner-icon="mdi-account"
										color="#F15A24"
										type="text"
										v-model="customer.name"
									>
									</v-text-field>
									<v-text-field
										filled
										label="Documento (CPF/CNPJ)"
										hide-details
										prepend-inner-icon="mdi-card-account-details"
										color="#F15A24"
										v-mask="
											customer.document.length <= 14
												? '###.###.###-##'
												: '##.###.###/####-##'
										"
										v-model="customer.document"
									>
									</v-text-field>
									<v-text-field
										filled
										label="E-mail"
										hide-details
										prepend-inner-icon="mdi-email"
										color="#F15A24"
										v-model="customer.email"
									>
									</v-text-field>
									<v-text-field
										filled
										label="Telefone"
										prepend-inner-icon="mdi-phone"
										color="#F15A24"
										v-mask="'(##) #####-####'"
										v-model="customer.telephone"
										hide-details
									>
									</v-text-field>
									<v-divider class="my-5"></v-divider>
									<h2 class="tituloForm mb-3">Crie sua senha</h2>
									<v-text-field
										color="#F15A24"
										hide-details
										filled
										prepend-inner-icon="mdi-lock"
										:type="showPass ? `text` : `password`"
										label="Crie uma senha"
										name="strPassword"
										v-model="customer.password"
										@click:append="showPass = !showPass"
										:append-icon="showPass ? `mdi-eye` : `mdi-eye-off`"
									>
									</v-text-field>
									<v-text-field
										prepend-inner-icon="mdi-lock-reset"
										color="#F15A24"
										filled
										@click:append="showConfirmPass = !showConfirmPass"
										:append-icon="showConfirmPass ? `mdi-eye` : `mdi-eye-off`"
										:type="showPass ? `text` : `password`"
										label="Confirme sua senha"
										name="strPassword"
										v-model="customer.confirmPassword"
									>
									</v-text-field>
									<v-checkbox
										v-model="customer.accept"
										color="#F15A24"
									>
										<template v-slot:label>
											<div class=" ">
												Ao seguir você aceita os <DialogTermos /> e a
												<DialogPolitica /> da plataforma.
											</div>
										</template>
									</v-checkbox>
									<div v-if="errors.length > 0">
										<p
											class="red--text font-weight-medium mb-1"
											v-for="(err, i) in errors"
											:key="`infoErr${i}`"
										>
											<v-icon
												color="red"
												small
												>mdi-circle-small</v-icon
											>
											{{ err }}
										</p>
									</div>
								</v-card-text>
							</v-card>
						</v-stepper-content>
						<v-stepper-content step="2">
							<v-card
								elevation="0"
								color="#f2f2f2"
							>
								<v-card-title> Endereço </v-card-title>
								<v-card-text>
									<div class="d-flex">
										<v-text-field
											style="width: 75%"
											hide-details
											color="#F15A24"
											filled
											v-mask="'#####-###'"
											label="CEP"
											@change="buscaCEP"
											prepend-inner-icon="mdi-map-marker"
											v-model="customer.address.zip_code"
										>
											<template v-slot:append-outer>
												<v-progress-circular
													v-if="loadingCEP"
													indeterminate
													:size="25"
												></v-progress-circular>
											</template>
										</v-text-field>
										<v-text-field
											style="width: 20%"
											hide-details
											color="#F15A24"
											filled
											label="País"
											prepend-inner-icon="mdi-flag"
											name=""
											v-model="customer.address.country"
										>
										</v-text-field>
									</div>

									<div class="d-flex">
										<v-text-field
											hide-details
											style="width: 75%"
											color="#F15A24"
											filled
											label="Cidade"
											prepend-inner-icon="mdi-home-group"
											type="text"
											name=""
											v-model="customer.address.city"
										/>
										<v-text-field
											style="width: 20%"
											hide-details
											color="#F15A24"
											filled
											prepend-inner-icon="mdi-town-hall"
											label="Estado"
											name=""
											v-model="customer.address.state"
										>
										</v-text-field>
									</div>
									<v-text-field
										hide-details
										color="#F15A24"
										prepend-inner-icon="mdi-home"
										filled
										label="Bairro"
										v-model="address.neighborhood"
									>
									</v-text-field>
									<div class="d-flex">
										<v-text-field
											style="width: 75%"
											hide-details
											color="#F15A24"
											filled
											label="Endereço"
											name=""
											v-model="address.line_1"
											prepend-inner-icon="mdi-text"
										>
										</v-text-field>
										<v-text-field
											ref="addrNumber"
											style="width: 20%"
											hide-details
											color="#F15A24"
											filled
											v-mask="'########'"
											label="Número"
											name=""
											prepend-inner-icon="mdi-numeric"
											v-model="address.number"
										>
										</v-text-field>
									</div>
									<v-text-field
										color="#F15A24"
										prepend-inner-icon="mdi-playlist-plus"
										filled
										label="Complemento"
										v-model="customer.address.line_2"
									>
									</v-text-field>
									<div v-if="errorsEnd.length > 0">
										<p
											class="red--text font-weight-medium mb-1"
											v-for="(err, i) in errorsEnd"
											:key="`endErr${i}`"
										>
											<v-icon
												color="red"
												small
												>mdi-circle-small</v-icon
											>
											{{ err }}
										</p>
									</div>
									<div v-if="errors.length > 0">
										<p
											class="red--text font-weight-medium mb-1"
											v-for="(err, i) in errors"
											:key="`endErr${i}`"
										>
											<v-icon
												color="red"
												small
												>mdi-circle-small</v-icon
											>
											{{ err }}
										</p>
									</div>
								</v-card-text>
							</v-card>
						</v-stepper-content>
						<v-stepper-content step="3" v-if="!planoGratuito && !cadastroSemPagamento">
							<v-card
								elevation="0"
								class="mb-12"
								color="#f2f2f2"
								style="padding: 10px"
							>
								<v-card-title>Informações de Pagamento</v-card-title>
								<v-card-text>
									<div v-if="isCupomGabinete" class="mb-4">
										<v-alert type="success" dense>
											<strong>Convite de Gabinete Ativo!</strong><br>
											Você receberá o Plano Legislativo sem necessidade de pagamento.
										</v-alert>
									</div>
									<h4>Plano Selecionado</h4>
									<v-select
										color="#F15A24"
										item-color="#F15A24"
										prepend-inner-icon="mdi-sign-text"
										v-model="payment.plan"
										:items="planos"
										item-text="titulo"
										item-value="url"
										:disabled="isCupomGabinete"
									>
									</v-select>
									<div v-if="!planoGratuito">
										<h4>Cupom Desconto</h4>
										<div class="d-flex">
											<v-text-field
												filled
												label="Cupom de desconto"
												v-model="coupon"
												prepend-inner-icon="mdi-ticket-percent"
												color="#F15A24"
												name="discount-coupon"
												:rules="couponRules"
												:class="{
													'error--text': !couponIsValid && couponTouched,
													'error--background': !couponIsValid && couponTouched,
												}"
												@input="verifyCoupon"
												@focus="couponTouched = true"
											/>
											<v-text-field
												filled
												v-if="coupon === `CAARJOAB10` && couponIsValid"
												color="#F15A24"
												prepend-inner-icon="mdi-file-document-edit-outline"
												v-model="customer.doc_cupom"
												label="Inclua número da OAB, Carteira da CAARJ ou Cartão Digital da CAARJ."
											></v-text-field>
										</div>
										<p v-if="couponSeleted.parceiro_cupom">
											<b>{{ couponSeleted.parceiro_cupom }}</b
											>: Desconto de {{ couponSeleted.desconto_cupom
											}}{{
												couponSeleted.tipo === `percentage` ? `%` : ` reais`
											}}
											nas próximas
											{{ couponSeleted.ciclos }}
											mensalidade{{ couponSeleted.ciclos > 1 ? `s` : `` }}.
										</p>
										<h4 class="mb-4">Cartão para assinatura</h4>
										<v-select
											:items="metodos"
											:item-color="`#F15A24`"
											color="#F15A24"
											item-text="title"
											item-value="value"
											hide-details
											v-model="customer.payment_method"
											filled
											label="Método de pagamento"
										></v-select>
										<v-text-field
											style="width: 100%"
											color="#F15A24"
											hide-details
											filled
											label="Nome do Titular"
											v-model="payment.holder_name"
											prepend-inner-icon="mdi-account-credit-card"
											name="holder-name"
										>
										</v-text-field>
										<v-text-field
											style="width: 100%"
											color="#F15A24"
											hide-details
											filled
											label="CPF do Titular"
											v-mask="'###.###.###-##'"
											v-model="payment.document"
											prepend-inner-icon="mdi-card-account-details"
											name="holder-document"
										>
										</v-text-field>
										<v-text-field
											style="width: 100%"
											color="#F15A24"
											hide-details
											filled
											v-mask="'#### #### #### ####'"
											prepend-inner-icon="mdi-credit-card"
											label="Número do cartão"
											v-model="payment.number"
											name="card-number"
										>
										</v-text-field>
										<div class="d-flex">
											<v-text-field
												style="width: 50%"
												color="#F15A24"
												hide-details
												prepend-inner-icon="mdi-calendar-month"
												filled
												v-mask="'##/####'"
												label="Data Expiração (MM/AAAA)"
												name="card-exp-month"
												v-model="payment.exp_month"
											>
											</v-text-field>
											<v-text-field
												style="width: 50%"
												color="#F15A24"
												hide-details
												filled
												v-mask="'###'"
												label="CVV"
												prepend-inner-icon="mdi-numeric"
												v-model="payment.cvv"
												name="cvv"
											>
											</v-text-field>
										</div>

										<v-text-field
											v-show="false"
											style="width: 100%"
											color="#F15A24"
											type="hidden"
											filled
											prepend-inner-icon="mdi-flag"
											label="address_id"
											v-model="customer.address.id"
											name="billind-address-id"
										>
										</v-text-field>
									</div>
									<div v-if="errors.length > 0">
										<p
											class="red--text font-weight-medium mb-1"
											v-for="(err, i) in errors"
											:key="`payErr${i}`"
										>
											<v-icon
												color="red"
												small
												>mdi-circle-small</v-icon
											>
											{{ err[0] ? err[0].message : err.message }}
										</p>
									</div>
								</v-card-text>
								<div class="d-flex mt-5">
									<v-btn
										class="mx-auto"
										:loading="loadingSub"
										color="#F15A24"
										dark
										@click="tokenCard"
									>
										Finalizar
									</v-btn>
								</div>
							</v-card>
						</v-stepper-content>
						<v-stepper-content step="4">
							<v-card
								elevation="0"
								class="mb-12 d-flex justify-center flex-column align-center"
								color="#f2f2f2"
								id="cadastroconcluido"
								height="200px"
								style="padding: 10px"
							>
								<v-img
									src="../assets/done.png"
									style="width: 100px"
									contain
								></v-img>
								<h1>Cadastro concluído</h1>
								<!-- <v-btn large to="/painel/legislacoes"> Acesse agora! </v-btn> -->
							</v-card>
							<v-form @submit="testeRef" id="cadastroConcluido" ref="cadastroConcluido" action="/concluido"></v-form>
							<!-- <v-btn @click="testeRef">teste ref</v-btn> -->
							<div class="d-flex justify-center mt-5">
								<v-btn
									to="/login"
									color="#F15A24"
									dark
								>
									Acesse Agora
								</v-btn>
							</div>
						</v-stepper-content>
						<div
							v-if="e1 < 3"
							class="d-flex justify-space-between justify-center mx-10 my-5"
						>
							<v-btn
								text
								@click="handleCancel"
							>
								{{ e1 > 1 ? `Voltar` : `` }}
							</v-btn>
							<v-btn
								:loading="loadingUser"
								color="#F15A24"
								dark
								@click="e1 === 1 ? checkForm() : e1 === 2 ? (planoGratuito ? checkForm() : postEndereco()) : ``"
							>
								{{ planoGratuito ? `Cadastrar` : `Próximo`}}
							</v-btn>
						</div>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
		<v-snackbar v-model="snackbar">
			{{ snackText }}

			<template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Ok
				</v-btn>
			</template>
		</v-snackbar>
		<v-dialog
			v-model="checkGoBack"
			width="20rem"
		>
			<v-card
				class="d-flex flex-column align-center justify-center pa-4"
				style="border-radius: 0.5rem"
			>
				<h3>Voltar ao Início?</h3>
				<p>Seus dados serão perdidos!</p>
				<div
					class="d-flex align-center justify-space-around"
					style="width: 100%"
				>
					<button
						class="btnNo"
						@click="checkGoBack = false"
					>
						Não
					</button>
					<router-link to="/">
						<button class="btnYes">Sim</button>
					</router-link>
				</div>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
	@media (min-device-width: 355px) and (max-device-width: 730px) {
		.widthMobile {
			width: 90% !important;
		}
	}

	form {
		background-color: #4d4d4f;
		max-width: 70%;
		margin: auto;
	}

	.bkgLogin {
		background-size: cover;
		background-position: center;
		background-color: #f15a24;
	}

	.bkgOverlay {
		background-color: rgba(0, 0, 0, 0);
		min-width: 100%;
		min-height: 100% !important;
		margin: 0;
		padding: 0;
	}

	.btnNo {
		background-color: red;
		color: white;
		border: none;
		border-radius: 0.3rem;
		padding: 0.3em 1rem;
	}

	.btnYes {
		background-color: #f15a24;
		color: white;
		border: none;
		border-radius: 0.3rem;
		padding: 0.3em 1rem;
	}
	.tituloForm {
		font-size: 1.25rem;
		font-weight: 500;
		color: black;
		letter-spacing: 0.0125em;
		line-height: 2rem;
		word-break: break-all;
	}
</style>

<script>
	import DialogPolitica from '../components/DialogPolitica.vue';
	import DialogTermos from '../components/DialogTermos.vue';
	import { CONTRATACAO_PLANOS_PAGOS_DESABILITADA } from '../config/contratacaoPlanos.js';

	/**
	 * Fluxo de pagamento no cadastro (gateway: payment/customers, payment/cards,
	 * payment/subscriptions). Quando `CONTRATACAO_PLANOS_PAGOS_DESABILITADA` é true
	 * em `src/config/contratacaoPlanos.js`, a etapa de cartão e o gateway são ignorados;
	 * após o endereço o plano é apenas gravado em `users.plano` e redireciona para `/obrigado`.
	 */

	export default {
		name: 'Cadastro',
		components: { DialogPolitica, DialogTermos },
		data() {
			return {
				snackbar: false,
				show1: false,
				loadingCEP: false,
				openPolitica: false,
				openTermos: false,
				showPass: false,
				showConfirmPass: false,
				loadingSub: false,
				e1: 1,
				loading: false,
				coupon: null,
				validCoupons: [],
				couponIsValid: false,
				couponTouched: false,
				metodos: [
					{ title: 'Cartão de Crédito', value: 'credit_card' },
					{ title: 'Cartão de Débito', value: 'debit_card' },
				],
				customer: {
					address: {
						zip_code: '',
						line_1: '',
						number: '',
						// 	country: "BR",
						// 	state: "SP",
						// 	city: "Sao Jose dos Campos",
						// 	line_1: "Travessa Jamil David",
						// 	line_2: "",
					},
					phones: {
						//   mobile_phone: {
						// 		country_code: "55",
						// 		area_code: "12",
						// 		number: "999999999",
						//   },
					},
					// birthdate: "1991/07/05",
					name: '',
					// email: "mteixeira.dev@gmail.com",
					// document: "93095135270",
					document_type: 'CPF',
					document: '',
					type: 'individual',
					payment_method: 'credit_card',
					email: '',
				},
				address: {
					line_1: '',
					zip_code: '',
					number: '',
					// number: "123",
					// neighborhood: "Vila Ema"
				},
				planos: [
					{
						id: 'plan_free',
						titulo: 'Plano Free (R$ 0,00)',
						url: 'plano-free',
					},
					{
						// id: "plan_XV7BG26TbcJoKxYv", //pagarme prod MyLegis
						id: 'plan_48jmqoxfpH5OzQ0P', // pagarme prod RAGA
						// id: "plan_1gknGVKCwC4vleX3",
						titulo: 'Plano Carreira (R$ 14,90)',
						url: 'plano-carreira',
					},
					{
						// id: "plan_3B1DKr3HVqUp8LG5", ///pagarme mylegis
						id: 'plan_vZJkelpIwIyeNq1M', // pagarme RAGA
						titulo: 'Plano Premium (R$ 49,90)',
						url: 'plano-premium',
					},
					{
						id: 'plan_g3180ooh6OSo0Wzx', // pagarme
						titulo: 'Plano Legislativo (R$ 499,90)',
						url: 'plano-legislativo',
					},
					{
						id: 'plan_lay6XlycO4TJw6e1',
						titulo: 'Plano Patrocínio (R$ 89,90)',
						url: 'plano-patrocinio',
					},
					// {
					//   id: "plan_XV7BG26TbcJoKxYv",
					//   titulo: "Plano Base (R$ 29,90)",
					//   url: "plano-base",
					// },
					// {
					//   id: "plan_3B1DKr3HVqUp8LG5",
					//   titulo: "Plano Avançado (R$ 49,90)",
					//   url: "plano-avancado",
					// },
				],
				// customer: {
				// 	address: {
				// 		country: "",
				// 		state: "",
				// 		city: "",
				// 		zip_code: "",
				// 		line_1: "",
				// 		line_2: "",
				// 	},
				// 	phones: {
				// 		mobile_phone: {
				// 			country_code: "",
				// 			area_code: "",
				// 			number: "",
				// 		},
				// 	},
				// 	birthdate: "",
				// 	name: "",
				// 	email: "",
				// 	document: "",
				// document_type: "CPF",
				// type: "individual",
				// },
				esqueciSenha: false,
				snackText: '',
				payment: {
					holder_name: '',
					plan: 'plano-free',
					exp_month: '',
					cvv: '',
					document: '',
					number: '',
				},
				initialized: false,
				loadingUser: false,
				checkGoBack: false,
				errors: [],
				errorsEnd: [],
				couponSeleted: {},
				cadastroSemPagamento: CONTRATACAO_PLANOS_PAGOS_DESABILITADA,
			};
		},
		computed: {
			user() {
				// window.window.console.log(this.$store.state.user.avatar)
				return this.$store.state.user != undefined
					? this.$store.state.user
					: { first_name: 'Meu Perfil' };
			},
			isCupomGabinete() {
				if (!this.couponIsValid || !this.couponSeleted) {
					return false;
				}
				// Verifica se tem admin_gabinete_id ou se o código começa com GABINETE_
				const isGabinete = !!(
					this.couponSeleted.admin_gabinete_id || 
					(this.couponSeleted.parceiro_cupom && this.couponSeleted.parceiro_cupom.toUpperCase().startsWith('GABINETE_'))
				);
				
				// Log para debug apenas quando há cupom na URL
				if (this.$route.query.cupom && isGabinete) {
					window.window.console.log('✅ isCupomGabinete computed retornou TRUE');
				}
				
				return isGabinete;
			},
			planoGratuito() {
				// Retorna true se for plano-free ou cupom de gabinete
				const isGratuito = this.payment.plan === 'plano-free' || this.isCupomGabinete;
				
				// Log para debug apenas quando há cupom na URL
				if (this.$route.query.cupom && isGratuito) {
					window.window.console.log('✅ planoGratuito computed retornou TRUE - step 3 deve estar oculto');
				}
				
				return isGratuito;
			},
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
			couponRules() {
				return [
					// (value) => !!value || "Digite um cupom de desconto",
					() =>
						!this.couponTouched ||
						this.couponIsValid ||
						'Cupom de desconto inválido',
				];
			},
		},
		async created() {
			window.console.log('=== CREATED - Iniciando verificação ===');
			window.console.log('URL completa:', this.$route.fullPath);
			window.console.log('Query params:', this.$route.query);
			window.console.log('Route params:', this.$route.params);
			
			// Verificar se há cupom de convite do gabinete na URL PRIMEIRO
			if (this.$route.query.cupom) {
				this.coupon = this.$route.query.cupom;
				this.couponTouched = true;
				window.console.log('Cupom encontrado na URL:', this.coupon);
			}
			
			// Buscar cupons ANTES de definir o plano
			await this.getCoupons();
			
			// Aguardar um tick para garantir que os computed properties sejam atualizados
			await this.$nextTick();
			
			// Verificar novamente após buscar cupons
			window.console.log('Após getCoupons:');
			window.console.log('- couponIsValid:', this.couponIsValid);
			window.console.log('- couponSeleted:', this.couponSeleted);
			window.console.log('- isCupomGabinete:', this.isCupomGabinete);
			window.console.log('- planoGratuito:', this.planoGratuito);
			window.console.log('- payment.plan:', this.payment.plan);
			
			// Depois verificar o plano da URL
			if (this.$route.params.plano) {
				// Só definir o plano da URL se não for cupom de gabinete
				if (!this.isCupomGabinete) {
					this.payment.plan = this.$route.params.plano;
					window.console.log('Plano da URL definido:', this.payment.plan);
				} else {
					window.console.log('Cupom de gabinete detectado, ignorando plano da URL');
				}
			}
			
			if (this.$route.query.cod === `lp_abare`) {
				this.planos = this.planos.filter((e) => e.id !== `plano-free`);
			}
			
			// Se for cupom de gabinete, garantir que o plano seja legislativo
			if (this.isCupomGabinete) {
				this.payment.plan = 'plano-free';
				window.console.log('✅ Cupom de gabinete detectado no created! Plano definido como:', this.payment.plan);
				window.console.log('✅ planoGratuito deve ser true:', this.planoGratuito);
			} else {
				window.console.log('❌ Não é cupom de gabinete');
			}
		},
		watch: {
			isCupomGabinete(newVal) {
				if (newVal) {
					window.console.log('Watcher: Cupom de gabinete detectado, definindo plano como legislativo');
					// this.payment.plan = 'plano-legislativo';
				}
			},
			'$route.query.cupom'(newVal) {
				if (newVal) {
					window.console.log('Watcher: Cupom na URL detectado, buscando cupons...');
					this.getCoupons();
				}
			},
		},
		methods: {
			testeRef( ) {
				window.window.console.log(`enviou form`) 
				//window.window.console.log()
				// this.$refs.cadastroConcluido.submit()
			},
			isValidCPF(cpf) {
				if (typeof cpf !== 'string') return false;
				cpf = cpf.replace(/[^\d]+/g, '');
				if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false;
				cpf = cpf.split('');
				const validator = cpf
					.filter((digit, index, array) => index >= array.length - 2 && digit)
					.map((el) => +el);
				const toValidate = (pop) =>
					cpf
						.filter(
							(digit, index, array) => index < array.length - pop && digit
						)
						.map((el) => +el);
				const rest = (count, pop) =>
					((toValidate(pop).reduce(
						(soma, el, i) => soma + el * (count - i),
						0
					) *
						10) %
						11) %
					10;
				return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
			},
			async checkForm() {
				this.errors = [];
				if (this.customer.name.length < 3) {
					this.errors.push('Por favor insira o Nome completo.');
				}
				if (this.customer.password)
					if (
						this.customer.document.length === 14 &&
						!this.isValidCPF(this.customer.document)
					) {
						this.errors.push('Por favor insira um CPF válido.');
					}
				if (this.customer.document.length < 14) {
					this.errors.push('Por favor insira um CPF válido.');
				}
				if (
					!String(this.customer.email)
						.toLowerCase()
						.match(
							/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
						)
				) {
					this.errors.push('Por favor insira um E-mail válido.');
				}
				if (!this.customer.password) {
					this.errors.push('Por favor insira uma senha.');
				}

				if (!this.customer.accept) {
					this.errors.push(
						'É necessario aceitar os Termos de Uso e Politica de Privacidade da plataforma.'
					);
				}

				if (
					this.customer.password &&
					this.customer.password != this.customer.confirmPassword
				) {
					this.errors.push('As senhas precisam ser iguais.');
				}
				if (this.errors.length > 0) return;
				
				// Verificar se é cupom de gabinete (acesso gratuito ao plano legislativo)
				const isCupomGabinete = this.isCupomGabinete;
				
				window.console.log('checkForm - isCupomGabinete:', isCupomGabinete);
				window.console.log('checkForm - planoGratuito:', this.planoGratuito);
				window.console.log('checkForm - payment.plan:', this.payment.plan);
				window.console.log(this.$route.query.grupo);
				
				if (this.payment.plan === 'plano-free' || isCupomGabinete) {
					const create = await this.postUser();
					if (create) {
						// Verificar se é convite para grupo de Eleitores
						const isConviteEleitores = this.$route.query.tipo === 'eleitores' && this.$route.query.grupo;
						
						if (isConviteEleitores) {
							// Adicionar ao grupo de Eleitores
							try {
								const grupoEleitoresId = this.$route.query.grupo;
								
								if (grupoEleitoresId) {
									window.console.log('Adicionando usuário ao grupo de Eleitores como INTEGRANTE:', grupoEleitoresId);
									
									// Adicionar usuário como integrante do grupo de Eleitores
									await this.$http.patch(`items/grupos/${grupoEleitoresId}`, {
										integrantes: {
											create: [{
												directus_users_id: { id: this.user.id },
												grupos_id: grupoEleitoresId
											}]
										}
									});
									
									window.console.log('✅ Usuário adicionado ao grupo de Eleitores como INTEGRANTE!');
									
									// Aguardar um pouco para garantir que o relacionamento foi salvo no Directus
									await new Promise(resolve => setTimeout(resolve, 500));
									
									// Recarregar as informações do usuário para garantir que os grupos estão atualizados
									window.console.log('🔄 Recarregando informações do usuário após adicionar ao grupo de Eleitores...');
									await this.$store.dispatch('getInfo');
								} else {
									window.console.warn('⚠️ ID do grupo de Eleitores não encontrado na URL');
								}
							} catch (err) {
								window.console.error('❌ Erro ao adicionar ao grupo de Eleitores:', err);
								if (err.response && err.response.data) {
									window.console.error('Detalhes do erro:', err.response.data);
								}
							}
							
							this.e1 = this.e1 + 3;
							this.$router.push('/obrigado/gratis');
						} else if (isCupomGabinete) {
							// Atribuir plano legislativo diretamente sem pagamento
							
							// Adicionar ao grupo do gabinete
							try {
								// Tentar obter o ID do grupo da URL primeiro
								let grupoGabineteId = this.$route.query.grupo;
								
								// Se não tiver na URL, buscar do cupom ou do admin
								if (!grupoGabineteId) {
									if (this.couponSeleted && this.couponSeleted.grupo_gabinete_id) {
										grupoGabineteId = this.couponSeleted.grupo_gabinete_id;
									} else if (this.couponSeleted && this.couponSeleted.admin_gabinete_id) {
										// Buscar grupo do gabinete do admin
										const grupoRes = await this.$http.get(
											`items/grupos?filter[user_created][_eq]=${this.couponSeleted.admin_gabinete_id}&filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id,nome_grupo`
										);
										
										if (grupoRes.data.data && grupoRes.data.data.length > 0) {
											grupoGabineteId = grupoRes.data.data[0].id;
										}
									}
								}
								
								if (grupoGabineteId) {
									window.console.log('Adicionando usuário ao grupo como INTEGRANTE (sem permissões de admin):', grupoGabineteId);
									
									// IMPORTANTE: Usuários com cupom de gabinete são adicionados APENAS como integrantes,
									// NÃO como administradores. Eles apenas participam do grupo, sem permissões de administração.
									// IMPORTANTE: Usuários com cupom de gabinete são adicionados APENAS como integrantes,
									// NÃO como administradores. Eles apenas participam do grupo, sem permissões de administração.
									// Estrutura correta do relacionamento many-to-many no Directus
									await this.$http.patch(`items/grupos/${grupoGabineteId}`, {
										integrantes: {
											create: [{
												directus_users_id: { id: this.user.id },
												grupos_id: grupoGabineteId
											}]
										}
										// NÃO adicionar em administradores - apenas integrante
									});
									
									window.console.log('✅ Usuário adicionado ao grupo do gabinete como INTEGRANTE (sem permissões de admin)!');
									
									// Aguardar um pouco para garantir que o relacionamento foi salvo no Directus
									await new Promise(resolve => setTimeout(resolve, 500));
								} else {
									window.console.warn('⚠️ ID do grupo do gabinete não encontrado');
								}
							} catch (err) {
								window.console.error('❌ Erro ao adicionar ao grupo do gabinete:', err);
								if (err.response && err.response.data) {
									window.console.error('Detalhes do erro:', err.response.data);
								}
							}
							
							// Atribuir plano legislativo e marcar como convidado
							await this.$http.patch('users/' + this.user.id, {
								plano: 'plano-legislativo',
								eh_convidado_gabinete: true,
								admin_gabinete_id: this.couponSeleted.admin_gabinete_id,
							});
							
							// Recarregar as informações do usuário para garantir que os grupos estão atualizados
							window.console.log('🔄 Recarregando informações do usuário após adicionar ao grupo...');
							await this.$store.dispatch('getInfo');
							
							this.e1 = this.e1 + 3;
							this.$router.push('/obrigado/gratis');
						} else {
							this.e1 = this.e1 + 3;
							this.$router.push('/obrigado/gratis');
						}
					}
				}
				else { 
					this.e1++;
				}
			},
			//holder-name=Tony Stark&card-number=4000000000000010&card-exp-month=1&card-exp-year=30&cvv=351

			formattedCurrentDay() {
				const currentDay = new Date();
				let formattedDay = currentDay.toISOString();
				formattedDay = formattedDay.slice(0, 10);
				const currentHour = currentDay.toLocaleTimeString('pt-BR');
				return `${formattedDay}T${currentHour}`;
			},
			async getCoupons() {
				try {
					const currentDay = this.formattedCurrentDay();
					const {
						data: { data },
					} = await this.$http.get(
						`items/cupom?filter[expire_date][_gt]=${currentDay}&fields=*,admin_gabinete_id,grupo_gabinete_id`
					);

					this.validCoupons = data;
					
					// Verificar cupom padrão LANCAMENTO10
					const isValid = this.validCoupons.find(
						(el) => el.parceiro_cupom.toUpperCase() === `LANCAMENTO10`
					);
					
					// Se houver cupom na URL (convite de gabinete), verificar se é válido
					if (this.$route.query.cupom) {
						const cupomGabinete = this.validCoupons.find(
							(el) => el.parceiro_cupom.toUpperCase() === this.$route.query.cupom.toUpperCase()
						);
						
						window.console.log('=== DEBUG CUPOM GABINETE ===');
						window.console.log('Cupom da URL:', this.$route.query.cupom);
						window.console.log('Cupom encontrado:', cupomGabinete);
						window.console.log('admin_gabinete_id:', cupomGabinete ? cupomGabinete.admin_gabinete_id : 'não encontrado');
						window.console.log('Todos os cupons válidos:', this.validCoupons);
						window.console.log(this.$route.query.grupo);
						
						// Verificar se é cupom de gabinete (tem admin_gabinete_id ou começa com GABINETE_)
						const isCupomGabinete = cupomGabinete && (
							cupomGabinete.admin_gabinete_id || 
							cupomGabinete.parceiro_cupom.toUpperCase().startsWith('GABINETE_')
						);
						
						if (isCupomGabinete) {
							this.couponIsValid = true;
							this.couponSeleted = cupomGabinete;
							this.coupon = this.$route.query.cupom.toUpperCase();
							// Se o cupom for de gabinete, definir o plano como legislativo
							this.payment.plan = 'plano-legislativo';
							window.console.log('✅ Cupom de gabinete detectado! Plano definido como:', this.payment.plan);
							window.console.log('isCupomGabinete computed:', this.isCupomGabinete);
							window.console.log('planoGratuito computed:', this.planoGratuito);
							
							// Forçar atualização reativa
							this.$nextTick(() => {
								window.console.log('Após nextTick - isCupomGabinete:', this.isCupomGabinete);
								window.console.log('Após nextTick - planoGratuito:', this.planoGratuito);
							});
						} else {
							window.console.log('❌ Cupom não é de gabinete ou não foi encontrado');
							if (!isValid) {
								this.couponIsValid = false;
								this.couponSeleted = {};
							}
						}
					} else {
						this.couponIsValid = !!isValid;
						this.couponSeleted = this.couponIsValid ? isValid : {};
						this.coupon = this.couponIsValid ? `LANCAMENTO10`.toUpperCase() : ``;
					}
					// window.window.console.log(data);
				} catch (error) {
					window.console.error(error);
				}
			},
			async verifyCoupon() {
				const isValid = this.validCoupons.find(
					(el) => el.parceiro_cupom.toUpperCase() === this.coupon.toUpperCase()
				);
				window.console.log(isValid);
				this.couponIsValid = !!isValid;
				this.couponSeleted = this.couponIsValid ? isValid : {};
				if (this.coupon.length === 0) {
					this.couponIsValid = true;
				}
			},
			sanitizeCard() {
				this.payment.document = this.payment.document.replace(/[^\d]/g, '');
				this.payment.number = this.payment.number.replace(/\s/g, '');
			},
			sanitizeCustomer() {
				const regex = /^\((\d{2})\)\s*(\d{4,5})-(\d{4})$/;
				const match = this.customer.telephone.match(regex);

				if (match[2].length === 4) {
					this.customer.phones.home_phone = {};
					this.customer.phones.home_phone.area_code = match[1];
					this.customer.phones.home_phone.number = match[2] + match[3];
					this.customer.phones.home_phone.country_code = '55';
				} else if (match[2].length === 5) {
					this.customer.phones.mobile_phone = {};
					this.customer.phones.mobile_phone.area_code = match[1];
					this.customer.phones.mobile_phone.number = match[2] + match[3];
					this.customer.phones.mobile_phone.country_code = '55';
				}

				this.customer.document = this.customer.document.replace(/[^\d]/g, '');
				this.customer.address.zip_code = this.customer.address.zip_code.replace(
					/[^\d]/g,
					''
				);
				this.customer.address.line_1 = `${this.address.number},${this.address.line_1},${this.address.neighborhood}`;
			},
			async login() {
				this.loading = true;
				// e.preventDefault();
				let email = this.customer.email;
				let password = this.customer.password;
				try {
					await this.$store.dispatch('login', { email, password });
					// Aguardar getInfo para garantir que os dados do usuário (incluindo grupos) estão atualizados
					await this.$store.dispatch('getInfo');
				} catch (error) {
					this.loading = false;
					this.snackText = 'Login inválido. Confira suas credenciais.';
					this.snackbar = true;
				}
			},
			tokenCard() {
				if (this.cadastroSemPagamento) {
					return;
				}
				if (this.payment.plan !== 'plano-free') {
					// window.window.console.log(this.payment)
					if (this.payment.exp_month.length < 7) {
						alert('Por favor insira a validade no formado MM/AAAA.');
						return;
					}
					if (this.payment.cvv.length < 3) {
						alert('Por favor insira o códivo de validação de tres digitos.');
						return;
					}
					this.loadingSub = true;
					this.errors = [];
					this.sanitizeCard();
					let month = this.payment.exp_month.split('/')[0];
					let year = this.payment.exp_month.split('/')[1];
					this.$http
						.post('payment/cards/' + this.customer.customer_id, {
							card: {
								number: this.payment.number,
								holder_name: this.payment.holder_name,
								holder_document: this.payment.document,
								exp_month: parseInt(month),
								exp_year: parseInt(year),
								cvv: this.payment.cvv,
								billing_address: this.customer.address,
							},
						})
						.then((res) => {
							this.payment.cardToken = res.data.id;
							this.postSubscription();
						})
						.catch((err) => {
							this.loadingSub = false;
							this.errors.push(err.response.data.errors[0]);
						});
				} else {
					this.e1++;
				}
			},
			async postEndereco() {
				// Se for cupom de gabinete, pular direto para checkForm (cadastro sem pagamento)
				if (this.isCupomGabinete) {
					window.console.log('postEndereco: Cupom de gabinete detectado, pulando para checkForm');
					await this.checkForm();
					return;
				}
				
				this.errorsEnd = [];
				if (this.customer.address.zip_code.length < 8) {
					this.errorsEnd.push('Por favor insira o CEP completo.');
				}
				if (this.address.line_1.length < 1) {
					this.errorsEnd.push('Por favor insira o endereço.');
				}
				if (this.address.number.length < 1) {
					this.errorsEnd.push('Por favor insira o número.');
				}
				if (this.errorsEnd.length > 0) return;
				this.loadingUser = true;
				const create = await this.postUser();
				window.console.log(create);
				try {
					this.loadingUser = true;
					await this.$http.post('/items/endereco', {
						pais: this.customer.address.country,
						estado: this.customer.address.state,
						cidade: this.customer.address.city,
						cep: this.customer.address.zip_code,
						rua: this.address.line_1,
						numero: this.address.number,
						bairro: this.address.neighborhood,
						complemento: this.customer.address.line_2,
					});
					this.postCustomer();
					this.loadingUser = false;
				} catch (err) {
					this.loadingUser = false;
					window.console.log(err);
				}
			},
			async postUser() {
				this.$http.defaults.headers.common['Authorization'] = undefined;
				try {
					await this.$http.post('/users', {
						first_name: this.customer.name,
						email: this.customer.email,
						password: this.customer.password,
						role: 'df55e59a-150c-4601-acc8-95e29683a39b',
						documento: this.customer.document,
						telefone: this.customer.telephone,
						cod_afiliado: this.$route.query.cod,
						doc_cupom: this.couponSeleted.parceiro_cupom || null,
					});

					// let formattedPhone = null;
					// if (this.customer.telephone) {
					// 	formattedPhone = this.customer.telephone.replace(/[^0-9]/g, '');
					// }

					// this.$http.post('/botconversa/flow', {
					// 	phone: formattedPhone,
					// 	name: this.customer.name,
					// });

					await this.login();
					this.loadingUser = false;
					return true;
				} catch (err) {
					if (err.response) {
						if (
							err.response.data.errors[0].extensions.code ===
							'RECORD_NOT_UNIQUE'
						) {
							this.errors.push('Este email já existe em nosso sitema!');
						} else {
							this.errors.push(err.response.data.errors[0].message);
						}
						this.loadingUser = false;
					}
				}
			},
			async postCustomer() {
				this.sanitizeCustomer();
				const mylegisId = 'f98bc34a-e46b-4392-9a68-8bc76a1694a5';

				this.$http.post('/items/meus_amigos', {
					id_amigo: this.user.id,
					id_usuario: mylegisId,
					status: 'published',
				});

				this.$http.post('/items/meus_amigos', {
					id_amigo: mylegisId,
					id_usuario: this.user.id,
					status: 'published',
				});

				if (
					this.cadastroSemPagamento &&
					this.payment.plan !== 'plano-free' &&
					!this.isCupomGabinete
				) {
					this.loadingUser = true;
					try {
						await this.$http.patch('users/' + this.user.id, {
							plano: this.payment.plan,
						});
					} catch (err) {
						window.console.error(err);
						const msg =
							err.response &&
							err.response.data &&
							err.response.data.errors &&
							err.response.data.errors[0]
								? err.response.data.errors[0].message
								: 'Erro ao atribuir o plano.';
						this.errors.push(msg);
						this.loadingUser = false;
						return;
					}
					this.loadingUser = false;
					this.e1 += 2;
					this.$router.push('/obrigado');
					return;
				}

				this.$http
					.post('payment/customers', { customer: this.customer })
					.then((res) => {
						this.customer.customer_id = res.data.id;
						this.customer.address_id = res.data.address.id;
						this.$http
							.patch('users/' + this.user.id, {
								customer_id: res.data.id,
								address_id: res.data.address.id,
							})
							.then(() => {});
						this.loadingUser = false;
						// Verificar se é cupom de gabinete
						const isCupomGabinete = this.couponIsValid && this.couponSeleted && this.couponSeleted.admin_gabinete_id;
						
						if (this.payment.plan == 'plano-free' || isCupomGabinete) {
							if (isCupomGabinete) {
								// Atribuir plano legislativo diretamente
								this.$http.patch('users/' + this.user.id, {
									plano: 'plano-legislativo',
								}).then(() => {
									// Adicionar ao grupo do gabinete
								// Tentar obter o ID do grupo da URL primeiro
								let grupoGabineteId = this.$route.query.grupo;
								window.console.log(grupoGabineteId);
								
								// Se não tiver na URL, buscar do cupom ou do admin
								if (!grupoGabineteId) {
									if (this.couponSeleted && this.couponSeleted.grupo_gabinete_id) {
										grupoGabineteId = this.couponSeleted.grupo_gabinete_id;
									} else if (this.couponSeleted && this.couponSeleted.admin_gabinete_id) {
										// Buscar grupo do gabinete do admin
										this.$http.get(
											`items/grupos?filter[user_created][_eq]=${this.couponSeleted.admin_gabinete_id}&filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id`
										).then((grupoRes) => {
											if (grupoRes.data.data && grupoRes.data.data.length > 0) {
												grupoGabineteId = grupoRes.data.data[0].id;
												// IMPORTANTE: Usuários com cupom de gabinete são adicionados APENAS como integrantes,
												// NÃO como administradores. Eles apenas participam do grupo, sem permissões de administração.
												// IMPORTANTE: Usar apenas o ID do usuário no relacionamento
												this.$http.patch(`items/grupos/${grupoGabineteId}`, {
													integrantes: {
														create: [{
															directus_users_id: this.user.id,
															grupos_id: grupoGabineteId
														}]
													}
													// NÃO adicionar em administradores - apenas integrante
												}).then(() => {
													window.console.log('✅ Usuário adicionado ao grupo como integrante');
												}).catch((err) => {
													window.console.error('Erro ao adicionar ao grupo do gabinete:', err);
												});
											}
										}).catch((err) => {
											window.console.error('Erro ao buscar grupo do gabinete:', err);
										});
									}
								} else {
									// Se já tem o ID do grupo, adicionar diretamente
									// IMPORTANTE: Usuários com cupom de gabinete são adicionados APENAS como integrantes,
									// NÃO como administradores. Eles apenas participam do grupo, sem permissões de administração.
									// IMPORTANTE: Usar apenas o ID do usuário no relacionamento
									this.$http.patch(`items/grupos/${grupoGabineteId}`, {
										integrantes: {
											create: [{
												directus_users_id: this.user.id,
												grupos_id: grupoGabineteId
											}]
										}
										// NÃO adicionar em administradores - apenas integrante
									}).then(() => {
										window.console.log('✅ Usuário adicionado ao grupo como integrante');
									}).catch((err) => {
										window.console.error('Erro ao adicionar ao grupo do gabinete:', err);
									});
								}
								});
							}
							this.e1 = this.e1 + 2;
							this.$router.push('/obrigado/gratis');
						} else {
							this.e1++;
						}
					});
			},
			postSubscription() {
				if (this.cadastroSemPagamento) {
					return;
				}
				this.loadingSub = true;
				let planSelected = this.planos.find((p) => p.url === this.payment.plan);
				const subscription = {
					plan_id: planSelected.id,
					payment_method: this.customer.payment_method,
					customer_id: this.customer.customer_id,
					card_id: this.payment.cardToken,
				};

				if (this.couponIsValid) {
					const couponData = this.validCoupons.find(
						(el) =>
							el.parceiro_cupom.toUpperCase() === this.coupon.toUpperCase()
					);

					subscription.discounts = [
						{
							cycles: couponData.ciclos,
							discount_type: couponData.tipo,
							value: `${couponData.desconto_cupom}`,
						},
					];
				}

				this.$http
					.post('payment/subscriptions', {
						subscription,
					})
					.then((res) => {
						if (res.data.status !== 'failed') {
							// Verificar se é cupom de gabinete e adicionar ao grupo
							const cupomGabinete = this.couponIsValid && this.couponSeleted && this.couponSeleted.admin_gabinete_id;
							
							if (cupomGabinete) {
								// Buscar o grupo do gabinete do admin
								this.$http.get(
									`items/grupos?filter[user_created][_eq]=${this.couponSeleted.admin_gabinete_id}&filter[restrito][_eq]=true&filter[nome_grupo][_contains]=Gabinete&fields=id`
								).then((grupoRes) => {
									if (grupoRes.data.data && grupoRes.data.data.length > 0) {
										const grupoGabineteId = grupoRes.data.data[0].id;
										// Adicionar usuário ao grupo do gabinete
										this.$http.patch(`items/grupos/${grupoGabineteId}`, {
											integrantes: {
												create: [{
													directus_users_id: { id: this.user.id },
													grupos_id: grupoGabineteId
												}]
											}
										}).catch((err) => {
											window.console.error('Erro ao adicionar ao grupo do gabinete:', err);
										});
									}
								}).catch((err) => {
									window.console.error('Erro ao buscar grupo do gabinete:', err);
								});
							}
							
							// add dt expiracao
							this.$http
								.patch('users/' + this.user.id, { plano: planSelected.url })
								.then(() => {
									this.e1++;
									this.$router.push('/obrigado');
								});
						} else {
							this.loadingSub = false;
							alert(
								'Ocorreu um erro no pagamento confira os dados e tente novamente.'
							);
						}
					})
					.catch((err) => {
						window.console.log(err);
						this.errors.push(err.response.data.errors);
						this.loadingSub = false;
					});
			},
			buscaCEP() {
				let cepStr = this.customer.address.zip_code;
				// window.window.console.log(cepStr)
				if (cepStr.length == 9) {
					this.loadingCEP = true;

					var cep = cepStr.replace(/\D/g, '');
					//Expressão regular para validar o CEP.
					var validacep = /^[0-9]{8}$/;
					//Valida o formato do CEP.
					if (validacep.test(cep)) {
						fetch('https://viacep.com.br/ws/' + cep + '/json')
							.then((response) => response.json())
							.then((data) => {
								this.customer.address.city = data.localidade;
								this.customer.address.country = 'BR';
								this.customer.address.state = data.uf;
								this.address.line_1 = data.logradouro;
								this.address.neighborhood = data.bairro;
								this.loadingCEP = false;
								this.$refs.addrNumber.focus();
								this.$forceUpdate();
							})
							.catch(() => {
								this.errors.push('Erro ao carregar o cep');
								this.loadingCEP = false;
							});
					}
					return cep;
				}
			},
			handleCancel() {
				if (this.e1 === 1) {
					this.checkGoBack = true;
				} else {
					this.e1--;
				}
			},
		},
	};
</script>
